module.exports = __webpack_public_path__ + "media/assets_v3/images/ininal-kart-barkod-49c40006a0df9fb170165f7ff89faef3.png";